(function() {
  const STORAGE_KEY = 'wishlist_ids';

  function getWishlist() {
    try {
      return JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];
    } catch {
      return [];
    }
  }

  function saveWishlist(ids) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(ids));
  }

  function updateButtons() {
    const ids = getWishlist();
    document.querySelectorAll('[data-wishlist-button]').forEach(btn => {
      const id = btn.dataset.productId;
      const wishlisted = ids.includes(id);
      btn.classList.toggle('is-wishlisted', wishlisted);
      btn.querySelector('span').textContent = wishlisted ? '♥' : '♡';
      btn.setAttribute('aria-pressed', wishlisted);
    });
  }

  function attachButton(btn) {
    if (btn._wishlistAttached) return;
    btn._wishlistAttached = true;
    btn.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      const id = btn.dataset.productId;
      let ids = getWishlist();
      if (ids.includes(id)) {
        ids = ids.filter(i => i !== id);
      } else {
        ids.push(id);
      }
      saveWishlist(ids);
      updateButtons();
    }, true);
  }

  function attachAll() {
    document.querySelectorAll('[data-wishlist-button]').forEach(attachButton);
  }

  const observer = new MutationObserver(function(mutations) {
    let hasNewButtons = false;
    mutations.forEach(function(m) {
      m.addedNodes.forEach(function(node) {
        if (node.nodeType === 1 && (node.matches('[data-wishlist-button]') || node.querySelector('[data-wishlist-button]'))) {
          hasNewButtons = true;
        }
      });
    });
    if (hasNewButtons) { attachAll(); updateButtons(); }
  });
  observer.observe(document.body, { childList: true, subtree: true });

  document.addEventListener('DOMContentLoaded', function() {
    attachAll();
    updateButtons();
  });
})();
